/**
 * Adapted from: http://code.google.com/p/gaequery/source/browse/trunk/src/static/scripts/jquery.autogrow-textarea.js
 *
 * Works nicely with the following styles:
 * textarea {
 *  resize: none;
 *  word-wrap: break-word;
 *  transition: 0.05s;
 *  -moz-transition: 0.05s;
 *  -webkit-transition: 0.05s;
 *  -o-transition: 0.05s;
 * }
 *
 * Usage: <textarea auto-grow></textarea>
 */

angular
.module('gc.ui.autoGrow', [])
.directive('autoGrow', [
'$timeout',
'$rootScope',
function ($timeout, $rootScope) {
  'use strict';
  return {
    link: function (scope, element, attrs) {
      var minHeight = element[0].offsetHeight;
      var cssVal = getComputedStyle(element[0], null);

      var $shadow = angular.element('<div class="text-area-shadow"></div>').css({
        position: 'absolute',
        top: '-10000px',
        left: '-10000px',
        width: element[0].offsetWidth + 'px',
        fontSize: cssVal.getPropertyValue('font-size'),
        fontFamily: cssVal.getPropertyValue('font-family'),
        lineHeight: cssVal.getPropertyValue('line-height'),
        resize: 'none'
      });

      angular.element(document.body).append($shadow);

      function nbsp() {
        return "&nbsp;";
      }

      function update() {
        var val = element.val()
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/&/g, '&amp;')
          .replace(/\n$/, '<br/>&nbsp;')
          .replace(/\n/g, '<br/>')
          .replace(/\s{2,}/g, function (space) {
            return space
                .substr(1)
                .split("")
                .map(nbsp)
                .join("") + "";
          });

        $shadow.css({
          lineHeight: cssVal.getPropertyValue('line-height'),
          fontSize: cssVal.getPropertyValue('font-size'),
          wordWrap: cssVal.getPropertyValue('word-wrap'),
          width: element[0].offsetWidth + 'px'
        });

        $shadow.html(val);
        var padding = attrs.autoGrowPadding ? Number(attrs.autoGrowPadding) : 20;
        element.css('height',
          Math.max($shadow[0].offsetHeight + padding, element.val() === "" ? minHeight : $shadow[0].offsetHeight + padding) + 'px'
        );
      }

      element.on('keyup keydown keypress change', update);
      setTimeout(function () {
        update();
      }, 1);

      scope.$on("$destroy", function () {
        element.off('keyup keydown keypress change', update);
        $shadow.remove();
      });

      $rootScope.$on('textarea:update', function () {
        element.val("");
        update();
      });
    }
  };
}]);
